<template>
  <div class="relative rounded-md px-6 sm:flex sm:items-start sm:justify-between">
    <ShowDataPanel
      v-if="autoGenerateTransferData || loading || transferData"
      :transferData="transferData"
      :loading="loading"
      class="mb-10 mt-5 w-full"
    />
    <GenerateDataPanel
      v-else-if="allowManualGenerateTransferData"
      :transferData="transferData"
      :loading="loading"
      v-model:loadingCreate="loadingCreating"
      class="my-10 w-full"
      @generateCVU="createTransferData"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

import GenerateDataPanel from "./GenerateDataPanel.vue";
import ShowDataPanel from "./ShowDataPanel.vue";

// Services
import { useInvoiceService } from "@services";

const props = withDefaults(
  defineProps<{
    autoGenerateTransferData?: boolean;
    allowManualGenerateTransferData: boolean;
  }>(),
  {
    autoGenerateTransferData: false,
  },
);

const invoicesService = useInvoiceService();

const loading = ref(false);
const loadingCreating = ref(false);
const transferData = ref<{
  cvu: string;
  alias: string;
}>();

const getTransferData = async () => {
  loading.value = true;

  const bankDetails = await invoicesService.getBankDetails();

  if (bankDetails.isErr()) {
    loading.value = false;
    return;
  }

  transferData.value = {
    cvu: bankDetails.value.cvu,
    alias: bankDetails.value.alias,
  };

  loading.value = false;
};

const createTransferData = async () => {
  loadingCreating.value = true;

  const bankDetails = await invoicesService.assignBankDetails();

  if (bankDetails.isErr()) {
    loadingCreating.value = false;
    return;
  }

  transferData.value = {
    cvu: bankDetails.value.cvu,
    alias: bankDetails.value.alias,
  };

  loadingCreating.value = false;
};

const getOrCreateTransferData = async () => {
  if (props.autoGenerateTransferData) {
    loading.value = true;
    await createTransferData();
    loading.value = false;
  } else {
    await getTransferData();
  }
};

onMounted(() => {
  getOrCreateTransferData();
});
</script>
